'use client';

import { forwardRef, useContext } from 'react';

import { ToneIcon } from '../tone-icon/tone-icon';
import { InlineFeedbackRootContext } from './context/inline-feedback-root.context';
import { inlineFeedbackIconRecipe } from './styles/inline-feedback-icon.styles';
import type { InlineFeedbackIconPropsInterface } from './types/inline-feedback-icon.types';

/**
 * @since 10.0.0
 */

export const InlineFeedbackIcon = forwardRef<SVGSVGElement, InlineFeedbackIconPropsInterface>(
  (props: InlineFeedbackIconPropsInterface, forwardedRef) => {
    const inlineFeedbackRootContext = useContext(InlineFeedbackRootContext);
    const { tone = inlineFeedbackRootContext.tone || 'info', css: cssProp, ...rest } = props;

    return (
      <ToneIcon
        ref={forwardedRef}
        data-c11n-component="InlineFeedback.Icon"
        data-c11n-version={__C11N_VERSION__}
        size="md"
        tone={tone}
        css={{
          ...inlineFeedbackIconRecipe.raw({ tone }),
          ...cssProp,
        }}
        {...rest}
      />
    );
  },
);

InlineFeedbackIcon.displayName = 'InlineFeedback.Icon';
